<template>
  <div>
    <script :id=id type="text/plain"></script>
    </div>
    </template>
    <script>
    import './../../static/ueditor/ueditor.config.js'
    import './../../static/ueditor/ueditor.all.js'
    import './../../static/ueditor/lang/zh-cn/zh-cn.js'
    import './../../static/ueditor/xiumi-ue-dialog-v5.js'

    export default {
      name: 'UE',
      data () {
        return {
          editor: null
        }
      },
      props: {
        config: {
          type: Object
        },
        id: {
          type: String
        },
        vaule:{
          type: String
        }
      },
      mounted() {




      },
      methods:{

        getUEContent() { // 获取内容方法
          return this.editor.getContent()
        },
        getUEContentTxt() { // 获取纯文本内容方法
          return this.editor.getContentTxt()
        },
        init(){
                console.log('1')
                console.log(UE.Editor.prototype._bkGetActionUrl)
        	if(UE.Editor.prototype._bkGetActionUrl === undefined){
            UE.Editor.prototype._bkGetActionUrl = UE.Editor.prototype.getActionUrl;
            UE.Editor.prototype.getActionUrl = function(action) {
              //判断路径   这里是config.json 中设置执行上传的action名称
              if (action == 'uploadimage') {
                console.log('123123')
                return '/back/file/qiniuUpload';
                //   return 'http://118.25.105.213:11088/back/file/upload';
              } else if (action == 'uploadvideo') {
                return '';
              } else {
                return this._bkGetActionUrl.call(this, action);
              }
            }
          }
                console.log('2')
          this.editor = UE.getEditor(this.id, this.config);
                console.log('3')
          this.editor.addListener("ready", ()=>{
            this.editor.setContent(this.config.initialContent); // 确保UE加载完成后，放入内容。
          });
                console.log('4')
          this.editor.addListener("contentChange", ()=>{
            this.$emit('input',this.getUEContent())
          })
                console.log('5')
          this.$emit('input',this.config.initialContent)
                console.log('6')

        }
      },
      destroyed() {
        this.editor.destroy();
      },
      watch:{
        config:{
          handler:function(val,oldval){
            console.log('简')
            this.init()
          },
          deep:true//对象内部的属性监听，也叫深度监听
        }
      }
    }
    </script>
    <style lang="scss">
      @import '../../static/ueditor/xiumi-ue-v5.css';
    </style>



// WEBPACK FOOTER //
// src/components/ueditor.vue